import PageNotFound from '../pages/PageNotFound'
import Welcome from '../pages/Welcome'
import Preregistered from '../pages/Preregistered'
import Dashboard from '../pages/Dashboard'

import FeedsList from '../pages/feeds/List'
import FeedsEdit from '../pages/feeds/Edit'
import FeedsIndex from '../pages/feeds/Index'

import AnalyticsList from '../pages/analytics/List'
import AnalyticsEdit from '../pages/analytics/Edit'
import AnalyticsIndex from '../pages/analytics/Index'

import InsightsQuery from '../pages/insights/Query'
import InsightsDisplay from '../pages/insights/Display'
import InsightsSettings from '../pages/insights/Settings'
import InsightsShare from '../pages/insights/Share'
import InsightsIndex from '../pages/insights/Index'

import UsersList from '../pages/users/List'
import UsersEdit from '../pages/users/Edit'
import UsersIndex from '../pages/users/Index'

import LayoutPublic from '../layouts/LayoutPublic'
import LayoutSecured from '../layouts/LayoutSecured'
import LayoutError from '../layouts/LayoutError'

import store from '../store'

export default [
  {
    name: 'welcome',
    path: '/welcome',
    component: Welcome,
    meta: {
      layout: LayoutPublic
    }
  },
  {
    name: 'preregistered',
    path: '/preregistered',
    component: Preregistered,
    meta: {
      layout: LayoutPublic
    }
  },
  {
    name: 'dashboard',
    path: '/dashboard',
    component: Dashboard,
    meta: {
      layout: LayoutSecured
      // breadcrumb: 'Nyitóoldal'
    }
  },
  {
    path: '/feeds',
    component: FeedsIndex,
    meta: {
      layout: LayoutSecured,
      breadcrumb: 'Hírfolyamok'
    },
    children: [
      {
        name: 'feeds',
        path: '',
        redirect: to => {
          return {name: 'feed-list'}
        }
      },
      {
        name: 'feed-list',
        path: 'list',
        component: FeedsList
      },
      {
        name: 'feed-edit',
        path: 'edit/:id?',
        component: FeedsEdit,
        meta: {
          breadcrumb ($route) {
            return $route.params.id ? 'Módosítás' : 'Létrehozás'
          }
        }
      }
    ]
  },
  {
    path: '/analytics',
    component: AnalyticsIndex,
    meta: {
      layout: LayoutSecured,
      breadcrumb: 'Elemzések'
    },
    children: [
      {
        name: 'analytics',
        path: '',
        redirect: to => {
          return {name: 'analytics-list'}
        }
      },
      {
        name: 'analytics-list',
        path: 'list',
        component: AnalyticsList
      },
      {
        name: 'analytics-edit',
        path: 'edit/:id?',
        component: AnalyticsEdit,
        meta: {
          breadcrumb ($route) {
            return $route.params.id ? 'Módosítás' : 'Létrehozás'
          }
        }
      }
    ]
  },
  {
    path: '/insights',
    component: InsightsIndex,
    meta: {
      layout: LayoutSecured,
      breadcrumb: 'Kimutatás'
    },
    children: [
      {
        name: 'insights',
        path: '',
        redirect: to => {
          return {name: 'insights-query'}
        }
      },
      {
        name: 'insights-query',
        path: 'query',
        component: InsightsQuery
      },
      {
        name: 'insights-settings',
        path: 'settings',
        component: InsightsSettings,
        meta: {
          breadcrumb: 'Beállítások'
        }
      },
      {
        name: 'insights-share',
        path: 'share',
        component: InsightsShare,
        meta: {
          breadcrumb: 'Megosztás'
        }
      },
      {
        name: 'insights-display',
        path: 'display',
        component: InsightsDisplay,
        meta: {
          breadcrumb: 'Megjelenítés'
        }
      }
    ]
  },
  {
    path: '/users',
    component: UsersIndex,
    meta: {
      layout: LayoutSecured,
      breadcrumb: 'Felhasználók'
    },
    children: [
      {
        name: 'users',
        path: '',
        redirect: to => {
          return {name: 'user-list'}
        }
      },
      {
        name: 'user-list',
        path: 'list',
        component: UsersList
      },
      {
        name: 'user-edit',
        path: 'edit/:id?',
        component: UsersEdit,
        meta: {
          breadcrumb ($route) {
            return $route.params.id ? 'Módosítás' : 'Létrehozás'
          }
        }
      }
    ]
  },
  {
    path: '',
    redirect: to => {
      if (store.state.user) {
        return {name: 'dashboard'}
      }
      return {name: 'welcome'}
    }
  },
  {
    path: '*',
    component: PageNotFound,
    meta: {
      layout: LayoutError
    }
  }
]



// WEBPACK FOOTER //
// ./src/components/routes/index.js